import { AppShell, ShellNavigation } from './shell/AppShell'
import { useShellSession } from './session'

/** The Control Board's navigation alone, for the pages that still lay out their own main column (Connections, Settings). */
export default function CustomerShellNavigation() {
  return <ShellNavigation session={useShellSession()} />
}

/** The Control Board's whole shell, for the pages built on its layout (Overview, Activity, Decisions, Agents). */
export function CustomerAppShell({ children }) {
  return <AppShell session={useShellSession()}>{children}</AppShell>
}
